import { render } from "./SaveAndQueue.vue?vue&type=template&id=557bb45a&scoped=true"
import script from "./SaveAndQueue.vue?vue&type=script&lang=js"
export * from "./SaveAndQueue.vue?vue&type=script&lang=js"

import "./SaveAndQueue.vue?vue&type=style&index=0&id=557bb45a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557bb45a"]])

export default __exports__